/**
 * Trims all the values in an object.
 * @param {any} obj - The object to trim.
 * @returns {any}
 */
export const trimAll = (obj: any) => {
    // if array, loop through and trim each object
    // if object, loop through and trim each object
    // if string, trim
    // if number, return
    // if boolean, return
    // if null, return
    // if undefined, return

    if (typeof obj === "undefined" || obj === null || typeof obj === "number") return obj;
    else if (typeof obj === "string") {
        return obj.trim();
    } else if (Array.isArray(obj)) {
        obj = obj.map((item) => trimAll(item));
    } else if (typeof obj === "object") {
        Object.keys(obj).forEach((key) => {
            obj[key] = trimAll(obj[key]);
        });
    }
    return obj;
};


/**
* Calculates the request time.
* @param {number} startTime - The start time of the request.
* @returns {number}
*/
export const calcRequestTime = (startTime: number = 0): number => {
    const now = new Date().getTime();
    return startTime === 0 ? 0 : now - startTime;
}
